import Axios from "axios";
import {
  SET_HRM_EMPLOYEE_LIST,
  UNSET_HRM_EMPLOYEE_LIST,
  SET_EMPLOYEE_DETAILS,
  UNSET_EMPLOYEE_DETAILS,
  SET_EMPLOYEE_SALARY_INFO,
  UNSET_EMPLOYEE_SALARY_INFO,
} from "@/store/mutation-types";
import {
  getHrmEmployeeList,
  saveUpdateEmployeeSetup,
  getEmployeeDetails,
  getEmployeeSalaryInfo,
} from "@/store/api";

const state = {
  employeeList: [],
  employeeDetails: null,
  employeeSalaryInfo: null,
};

const getters = {
  getEmployeeList(state) {
    return state.employeeList;
  },
  getEmployeeDetailsData(state) {
    return state.employeeDetails;
  },
  getEmployeeSalaryInfo(state) {
    return state.employeeSalaryInfo;
  },
};

const mutations = {
  [SET_HRM_EMPLOYEE_LIST](state, data) {
    state.employeeList = data;
  },
  [UNSET_HRM_EMPLOYEE_LIST](state) {
    state.employeeList = [];
  },
  [SET_EMPLOYEE_DETAILS](state, data) {
    state.employeeDetails = data;
  },
  [UNSET_EMPLOYEE_DETAILS](state) {
    state.employeeDetails = null;
  },
  [SET_EMPLOYEE_SALARY_INFO](state, data) {
    state.employeeSalaryInfo = data;
  },
  [UNSET_EMPLOYEE_SALARY_INFO](state) {
    state.employeeSalaryInfo = null;
  },
};

const actions = {
  getEmployees({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeList, { params })
        .then((response) => {
          commit(SET_HRM_EMPLOYEE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_EMPLOYEE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveEmployee({ commit }, employeeData) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateEmployeeSetup, employeeData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getEmployeeDetailsById({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeDetails}/${employeeId}`)
        .then((response) => {
          commit(SET_EMPLOYEE_DETAILS, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_DETAILS);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getEmployeeSalaryInfoById({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      Axios.get(getEmployeeSalaryInfo(employeeId))
        .then((response) => {
          commit(SET_EMPLOYEE_SALARY_INFO, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_SALARY_INFO);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

